import Swal from 'sweetalert2'

class swalHelper {
  static success ({ title, text, confirmButton = 'OK' }, additionalSettings = {}) {
    return Swal.fire({
      icon: 'success',
      confirmButtonText: confirmButton,
      title,
      ...additionalSettings
    })
  }

  static async warning ({ title, text, confirmButton = 'OK', cancelButton = 'Cancel' }) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: !0,
      confirmButtonColor: '#fd397a',
      confirmButtonText: confirmButton,
      cancelButtonText: cancelButton,
      closeOnConfirm: !1
    })
  }

  static error ({ title, text, confirmButton = 'OK' }) {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonColor: '#fd397a',
      confirmButtonText: confirmButton
    })
  }

  static displayCatchError ({ title, errorObject, confirmButton = 'OK' }) {
    let text = ''
    let validationErrors = {}

    if (errorObject.response) {
      if (errorObject.response.data.errors) {
        validationErrors = errorObject.response.data.errors
        text = errorObject.response.data.message

        this.error({ title, text, confirmButton })
        return {
          validationErrors
        }
      }

      // TODO: Check where .error is coming from (Ex. Login)
      if (errorObject.response.data.error) {
        text = errorObject.response.data.message

        this.error({ title, text, confirmButton })
        return {
          validationErrors
        }
      }

      if (typeof errorObject.response.data !== 'undefined') {
        text = errorObject.response.data

        this.error({ title, text, confirmButton })
        return {
          validationErrors
        }
      } else {
        text = errorObject.response.data.message

        this.error({ title, text, confirmButton })
        return {
          validationErrors
        }
      }
    } else {
      text = errorObject

      this.error({ title, text, confirmButton })
      return {
        validationErrors
      }
    }
  }
}

export default swalHelper
